import gql from 'graphql-tag';

export const DeleteTripDocumentBulk = gql`
  mutation DeleteTripDocumentBulk($input: DeleteTripDocumentBulkInput!) {
    deleteTripDocumentBulk(input: $input) {
      deleted
    }
  }
`;
